// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Reset and base styles */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  background-color: #f1f5f9;
  color: #1e293b;
  font-family: 'Inter', sans-serif;
  height: 100vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

/* Utility classes for layout */
.min-h-screen { min-height: 100vh; }
.h-screen { height: 100vh; }
.flex { display: flex; }
.flex-col { flex-direction: column; }
.flex-1 { flex: 1 1; }
.items-center { align-items: center; }
.justify-center { justify-content: center; }
.justify-between { justify-content: space-between; }
.gap-1 { gap: 0.25rem; }
.gap-2 { gap: 0.5rem; }
.gap-3 { gap: 0.75rem; }
.gap-4 { gap: 1rem; }
.gap-6 { gap: 1.5rem; }
.space-y-1 > * + * { margin-top: 0.25rem; }
.space-y-4 > * + * { margin-top: 1rem; }
.space-y-6 > * + * { margin-top: 1.5rem; }
.space-x-2 > * + * { margin-left: 0.5rem; }

/* Width and sizing */
.w-4 { width: 1rem; }
.w-5 { width: 1.25rem; }
.w-10 { width: 2.5rem; }
.w-12 { width: 3rem; }
.w-64 { width: 16rem; }
.w-full { width: 100%; }
.h-12 { height: 3rem; }

/* Padding and margin */
.p-4 { padding: 1rem; }
.p-6 { padding: 1.5rem; }
.p-8 { padding: 2rem; }
.px-2 { padding-left: 0.5rem; padding-right: 0.5rem; }
.px-4 { padding-left: 1rem; padding-right: 1rem; }
.px-6 { padding-left: 1.5rem; padding-right: 1.5rem; }
.px-8 { padding-left: 2rem; padding-right: 2rem; }
.py-1 { padding-top: 0.25rem; padding-bottom: 0.25rem; }
.py-2 { padding-top: 0.5rem; padding-bottom: 0.5rem; }
.py-2\\.5 { padding-top: 0.625rem; padding-bottom: 0.625rem; }
.py-3 { padding-top: 0.75rem; padding-bottom: 0.75rem; }
.py-4 { padding-top: 1rem; padding-bottom: 1rem; }
.pb-4 { padding-bottom: 1rem; }
.mb-2 { margin-bottom: 0.5rem; }
.mb-3 { margin-bottom: 0.75rem; }
.mb-4 { margin-bottom: 1rem; }
.mb-6 { margin-bottom: 1.5rem; }
.mb-8 { margin-bottom: 2rem; }
.ml-3 { margin-left: 0.75rem; }
.ml-4 { margin-left: 1rem; }
.ml-6 { margin-left: 1.5rem; }
.mt-1 { margin-top: 0.25rem; }

/* Colors */
.bg-white { background-color: white; }
.bg-gray-50 { background-color: #f9fafb; }
.bg-gray-100 { background-color: #f3f4f6; }
.bg-surface { background-color: #f1f5f9; }
.bg-crimson { background-color: #981b1e; }
.bg-slate { background-color: #1e293b; }
.bg-transparent { background-color: transparent; }
.bg-red-800 { background-color: #991b1b; }
.bg-blue-500 { background-color: #3b82f6; }
.bg-blue-600 { background-color: #2563eb; }
.bg-green-500 { background-color: #10b981; }
.bg-green-600 { background-color: #059669; }
.bg-purple-500 { background-color: #8b5cf6; }
.bg-purple-600 { background-color: #7c3aed; }
.bg-red-500 { background-color: #ef4444; }
.bg-red-600 { background-color: #dc2626; }
.text-white { color: white; }
.text-slate { color: #1e293b; }
.text-gray-500 { color: #6b7280; }
.text-gray-600 { color: #4b5563; }
.text-crimson { color: #981b1e; }
.text-gold { color: #d4af37; }
.text-blue-500 { color: #3b82f6; }
.text-green-500 { color: #10b981; }

/* Borders */
.border { border-width: 1px; }
.border-2 { border-width: 2px; }
.border-r { border-right-width: 1px; }
.border-b { border-bottom-width: 1px; }
.border-l-4 { border-left-width: 4px; }
.border-border_gray { border-color: #e2e8f0; }
.border-gray-200 { border-color: #e5e7eb; }
.border-white { border-color: white; }
.border-crimson { border-color: #981b1e; }
.border-blue-500 { border-color: #3b82f6; }
.border-green-500 { border-color: #10b981; }
.rounded { border-radius: 0.25rem; }
.rounded-lg { border-radius: 0.5rem; }
.rounded-xl { border-radius: 0.75rem; }

/* Shadows */
.shadow-sm { box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05); }
.shadow-md { box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06); }
.shadow-lg { box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05); }
.shadow-float { box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1); }

/* Typography */
.font-sans { font-family: 'Inter', sans-serif; }
.font-serif { font-family: 'Playfair Display', serif; }
.font-medium { font-weight: 500; }
.font-semibold { font-weight: 600; }
.font-bold { font-weight: 700; }
.text-xs { font-size: 0.75rem; }
.text-sm { font-size: 0.875rem; }
.text-lg { font-size: 1.125rem; }
.text-xl { font-size: 1.25rem; }
.text-2xl { font-size: 1.5rem; }
.text-3xl { font-size: 1.875rem; }
.uppercase { text-transform: uppercase; }
.tracking-wider { letter-spacing: 0.05em; }

/* Overflow */
.overflow-hidden { overflow: hidden; }
.overflow-y-auto { overflow-y: auto; }

/* Transitions */
.transition-all { transition: all 0.2s; }
.duration-200 { transition-duration: 200ms; }
.transition-transform { transition: transform 0.2s; }
.transition-colors { transition: color 0.2s, background-color 0.2s, border-color 0.2s; }

/* Transforms */
.rotate-180 { transform: rotate(180deg); }
.transform { transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)); }
.hover\\:-translate-y-1:hover { transform: translateY(-0.25rem); }

/* Hover effects */
.hover\\:bg-gray-50:hover { background-color: #f9fafb; }
.hover\\:bg-red-800:hover { background-color: #991b1b; }
.hover\\:bg-white:hover { background-color: white; }
.hover\\:bg-blue-600:hover { background-color: #2563eb; }
.hover\\:bg-green-600:hover { background-color: #059669; }
.hover\\:bg-purple-600:hover { background-color: #7c3aed; }
.hover\\:bg-red-600:hover { background-color: #dc2626; }
.hover\\:text-crimson:hover { color: #981b1e; }
.hover\\:text-slate:hover { color: #1e293b; }
.hover\\:shadow-md:hover { box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06); }

/* Position */
.absolute { position: absolute; }
.relative { position: relative; }
.top-0 { top: 0; }
.left-0 { left: 0; }

/* Display */
.block { display: block; }
.inline-block { display: inline-block; }
.hidden { display: none; }

/* Cursor */
.cursor-pointer { cursor: pointer; }

/* Text decoration */
.no-underline { text-decoration: none; }

/* Responsive breakpoints */
@media (min-width: 640px) {
  .sm\\:py-3 { padding-top: 0.75rem; padding-bottom: 0.75rem; }
  .sm\\:py-4 { padding-top: 1rem; padding-bottom: 1rem; }
  .sm\\:px-8 { padding-left: 2rem; padding-right: 2rem; }
  .sm\\:text-base { font-size: 1rem; }
  .sm\\:text-lg { font-size: 1.125rem; }
}

/* BRAND LOGO STYLES */
.brand-logo {
  display: flex;
  align-items: center;
  gap: 12px;
  text-decoration: none;
}

.shield-icon {
  width: 42px;
  height: 50px;
  background: linear-gradient(135deg, #981b1e 0%, #721215 100%);
  border-radius: 4px 4px 24px 24px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 10px rgba(152, 27, 30, 0.25);
  flex-shrink: 0;
}

.shield-icon::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 4px;
  background: #d4af37;
  border-radius: 4px 4px 0 0;
}

.shield-char {
  color: white;
  font-family: 'Playfair Display', serif;
  font-weight: 900;
  font-size: 28px;
  margin-top: 3px;
  font-style: italic;
}

/* Large Logo */
.shield-icon.large {
  width: 120px;
  height: 144px;
  border-radius: 8px 8px 60px 60px;
}

.shield-icon.large::before {
  height: 8px;
  border-radius: 8px 8px 0 0;
}

.shield-icon.large .shield-char {
  font-size: 80px;
  margin-top: 6px;
}

/* UI UTILITIES */
.fade-in {
  animation: fadeIn 0.4s cubic-bezier(0.4, 0, 0.2, 1) forwards;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

::-webkit-scrollbar {
  width: 6px;
}

::-webkit-scrollbar-track {
  background: transparent;
}

::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 3px;
}

/* HERO STYLES */
.hero-bg-image {
  background-image: url('https://images.unsplash.com/photo-1523580494863-6f3031224c94?ixlib=rb-1.2.1&auto=format&fit=crop&w=1950&q=80');
  background-size: cover;
  background-position: center 20%;
}

.hero-overlay {
  background: linear-gradient(to right, rgba(152, 27, 30, 0.95) 0%, rgba(152, 27, 30, 0.7) 60%, rgba(212, 175, 55, 0.2) 100%);
}

/* MEGA MENU */
.group:hover .mega-menu {
  display: block;
  animation: slideDown 0.2s ease-out;
}

@keyframes slideDown {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* ADMIN PANEL STYLES */
.admin-container {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.admin-header {
  background: #1f2937;
  color: white;
  padding: 1rem 2rem;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.admin-main {
  display: flex;
  flex: 1 1;
}

.admin-sidebar {
  width: 250px;
  background: #374151;
  color: white;
  padding: 1rem 0;
  box-shadow: 2px 0 4px rgba(0,0,0,0.1);
}

.admin-content {
  flex: 1 1;
  padding: 2rem;
  background: #f9fafb;
}

.sidebar-nav {
  list-style: none;
}

.sidebar-nav li {
  border-bottom: 1px solid #4b5563;
}

.sidebar-nav a {
  display: block;
  padding: 1rem 1.5rem;
  color: white;
  text-decoration: none;
  transition: background-color 0.2s;
}

.sidebar-nav a:hover,
.sidebar-nav a.active {
  background: #1f2937;
}

.sidebar-nav i {
  margin-right: 0.75rem;
  width: 1.25rem;
  text-align: center;
}

/* Admin Form Styles */
.form-group {
  margin-bottom: 1.5rem;
}

.form-label {
  display: block;
  margin-bottom: 0.5rem;
  font-weight: 600;
  color: #374151;
}

.form-input,
.form-textarea,
.form-select {
  width: 100%;
  padding: 0.75rem;
  border: 1px solid #d1d5db;
  border-radius: 0.375rem;
  font-size: 0.875rem;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

.form-input:focus,
.form-textarea:focus,
.form-select:focus {
  outline: 0;
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}

.form-textarea {
  min-height: 100px;
  resize: vertical;
}

/* Admin Button Styles */
.btn {
  padding: 0.75rem 1.5rem;
  border: none;
  border-radius: 0.375rem;
  font-weight: 600;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  cursor: pointer;
  transition: all 0.15s ease-in-out;
  font-size: 0.875rem;
}

.btn-primary {
  background: #3b82f6;
  color: white;
}

.btn-primary:hover {
  background: #2563eb;
}

.btn-secondary {
  background: #6b7280;
  color: white;
}

.btn-secondary:hover {
  background: #4b5563;
}

.btn-success {
  background: #10b981;
  color: white;
}

.btn-success:hover {
  background: #059669;
}

.btn-danger {
  background: #ef4444;
  color: white;
}

.btn-danger:hover {
  background: #dc2626;
}

.btn-sm {
  padding: 0.5rem 1rem;
  font-size: 0.75rem;
}

/* Admin Card Styles */
.card {
  background: white;
  border-radius: 0.5rem;
  box-shadow: 0 1px 3px rgba(0,0,0,0.1);
  overflow: hidden;
}

.card-header {
  padding: 1.5rem 2rem;
  border-bottom: 1px solid #e5e7eb;
  background: #f9fafb;
}

.card-title {
  font-size: 1.25rem;
  font-weight: 600;
  color: #111827;
}

.card-body {
  padding: 2rem;
}

/* Admin Table Styles */
.table {
  width: 100%;
  border-collapse: collapse;
  margin: 1rem 0;
}

.table th,
.table td {
  padding: 0.75rem;
  text-align: left;
  border-bottom: 1px solid #e5e7eb;
}

.table th {
  background: #f9fafb;
  font-weight: 600;
  color: #374151;
}

.table tbody tr:hover {
  background: #f9fafb;
}

/* Admin Alert Styles */
.alert {
  padding: 1rem;
  border-radius: 0.375rem;
  margin-bottom: 1rem;
}

.alert-success {
  background: #d1fae5;
  border: 1px solid #34d399;
  color: #065f46;
}

.alert-error {
  background: #fee2e2;
  border: 1px solid #f87171;
  color: #991b1b;
}

.alert-warning {
  background: #fef3c7;
  border: 1px solid #fbbf24;
  color: #92400e;
}

/* Admin Utility Classes */
.text-center { text-align: center; }
.text-right { text-align: right; }
.mb-4 { margin-bottom: 1rem; }
.mb-8 { margin-bottom: 2rem; }
.mt-4 { margin-top: 1rem; }
.flex { display: flex; }
.flex-1 { flex: 1 1; }
.items-center { align-items: center; }
.justify-between { justify-content: space-between; }
.gap-4 { gap: 1rem; }
.hidden { display: none; }

@media (max-width: 768px) {
  .admin-main {
    flex-direction: column;
  }
  
  .admin-sidebar {
    width: 100%;
  }
  
  .admin-content {
    padding: 1rem;
  }
}

/* Rich Text Content Styles */
.rich-text-content {
  line-height: 1.7 !important;
  font-family: 'Inter', sans-serif !important;
}

.rich-text-content *:not(code):not(pre) {
  font-family: 'Inter', sans-serif !important;
  line-height: 1.7 !important;
}

.rich-text-content p {
  margin-bottom: 1rem;
}

.rich-text-content p:last-child {
  margin-bottom: 0;
}

.rich-text-content ul, 
.rich-text-content ol {
  margin-left: 1.5rem;
  margin-bottom: 1rem;
  padding-left: 0.5rem;
}

.rich-text-content ul {
  list-style-type: disc;
}

.rich-text-content ol {
  list-style-type: decimal;
}

.rich-text-content ul ul, 
.rich-text-content ol ul {
  list-style-type: circle;
  margin-top: 0.5rem;
}

.rich-text-content ol ol, 
.rich-text-content ul ol {
  list-style-type: lower-alpha;
  margin-top: 0.5rem;
}

.rich-text-content li {
  margin-bottom: 0.5rem;
  padding-left: 0.25rem;
}

.rich-text-content li:last-child {
  margin-bottom: 0;
}

.rich-text-content h1, 
.rich-text-content h2, 
.rich-text-content h3, 
.rich-text-content h4, 
.rich-text-content h5, 
.rich-text-content h6 {
  font-weight: 600;
  margin-bottom: 0.75rem;
  margin-top: 1.5rem;
}

.rich-text-content h1:first-child, 
.rich-text-content h2:first-child, 
.rich-text-content h3:first-child, 
.rich-text-content h4:first-child, 
.rich-text-content h5:first-child, 
.rich-text-content h6:first-child {
  margin-top: 0;
}

.rich-text-content h1 { font-size: 2rem; }
.rich-text-content h2 { font-size: 1.5rem; }
.rich-text-content h3 { font-size: 1.25rem; }
.rich-text-content h4 { font-size: 1.125rem; }
.rich-text-content h5 { font-size: 1rem; }
.rich-text-content h6 { font-size: 0.875rem; }

.rich-text-content strong, 
.rich-text-content b {
  font-weight: 600;
}

.rich-text-content em, 
.rich-text-content i {
  font-style: italic;
}

.rich-text-content u {
  text-decoration: underline;
}

.rich-text-content blockquote {
  border-left: 4px solid #e5e7eb;
  padding-left: 1rem;
  margin-left: 0;
  margin-bottom: 1rem;
  font-style: italic;
  color: #6b7280;
}

.rich-text-content a {
  color: #3b82f6;
  text-decoration: underline;
}

.rich-text-content a:hover {
  color: #1d4ed8;
}

.rich-text-content code {
  background-color: #f3f4f6;
  padding: 0.125rem 0.25rem;
  border-radius: 0.25rem;
  font-family: 'Courier New', monospace;
  font-size: 0.875em;
}

.rich-text-content pre {
  background-color: #f3f4f6;
  padding: 1rem;
  border-radius: 0.5rem;
  overflow-x: auto;
  margin-bottom: 1rem;
}

.rich-text-content pre code {
  background-color: transparent;
  padding: 0;
}

/* Preserve inline styles from rich text editor */
.rich-text-content p[style*="text-align: justify"] {
  text-align: justify !important;
}

.rich-text-content p[style*="text-align: left"] {
  text-align: left !important;
}

.rich-text-content p[style*="text-align: center"] {
  text-align: center !important;
}

.rich-text-content p[style*="text-align: right"] {
  text-align: right !important;
}

/* Support for MS Word-style classes */
.rich-text-content .MsoNormal {
  margin: 0 !important;
  padding: 0 !important;
  line-height: 1.7 !important;
}

/* Override Word/CMS inline spacing on spans */
.rich-text-content span {
  line-height: 1.7 !important;
  font-size: inherit !important;
}

/* Preserve line breaks and spacing from rich text editor */
.rich-text-content br {
  line-height: 1.7;
}

.rich-text-content p:empty {
  margin-bottom: 0.5rem;
  min-height: 0;
}

.rich-text-content div:empty {
  margin-bottom: 0.5rem;
  min-height: 0;
}

/* Ensure proper spacing for consecutive paragraphs */
.rich-text-content p + p {
  margin-top: 0;
}

/* Remove extra spacing from hidden/blank content */
.rich-text-content *:empty:not(br):not(img) {
  margin: 0;
  padding: 0;
  min-height: 0;
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA,0BAA0B;AAC1B;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,gCAAgC;EAChC,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA,+BAA+B;AAC/B,gBAAgB,iBAAiB,EAAE;AACnC,YAAY,aAAa,EAAE;AAC3B,QAAQ,aAAa,EAAE;AACvB,YAAY,sBAAsB,EAAE;AACpC,UAAU,SAAO,EAAE;AACnB,gBAAgB,mBAAmB,EAAE;AACrC,kBAAkB,uBAAuB,EAAE;AAC3C,mBAAmB,8BAA8B,EAAE;AACnD,SAAS,YAAY,EAAE;AACvB,SAAS,WAAW,EAAE;AACtB,SAAS,YAAY,EAAE;AACvB,SAAS,SAAS,EAAE;AACpB,SAAS,WAAW,EAAE;AACtB,qBAAqB,mBAAmB,EAAE;AAC1C,qBAAqB,gBAAgB,EAAE;AACvC,qBAAqB,kBAAkB,EAAE;AACzC,qBAAqB,mBAAmB,EAAE;;AAE1C,qBAAqB;AACrB,OAAO,WAAW,EAAE;AACpB,OAAO,cAAc,EAAE;AACvB,QAAQ,aAAa,EAAE;AACvB,QAAQ,WAAW,EAAE;AACrB,QAAQ,YAAY,EAAE;AACtB,UAAU,WAAW,EAAE;AACvB,QAAQ,YAAY,EAAE;;AAEtB,uBAAuB;AACvB,OAAO,aAAa,EAAE;AACtB,OAAO,eAAe,EAAE;AACxB,OAAO,aAAa,EAAE;AACtB,QAAQ,oBAAoB,EAAE,qBAAqB,EAAE;AACrD,QAAQ,kBAAkB,EAAE,mBAAmB,EAAE;AACjD,QAAQ,oBAAoB,EAAE,qBAAqB,EAAE;AACrD,QAAQ,kBAAkB,EAAE,mBAAmB,EAAE;AACjD,QAAQ,oBAAoB,EAAE,uBAAuB,EAAE;AACvD,QAAQ,mBAAmB,EAAE,sBAAsB,EAAE;AACrD,WAAW,qBAAqB,EAAE,wBAAwB,EAAE;AAC5D,QAAQ,oBAAoB,EAAE,uBAAuB,EAAE;AACvD,QAAQ,iBAAiB,EAAE,oBAAoB,EAAE;AACjD,QAAQ,oBAAoB,EAAE;AAC9B,QAAQ,qBAAqB,EAAE;AAC/B,QAAQ,sBAAsB,EAAE;AAChC,QAAQ,mBAAmB,EAAE;AAC7B,QAAQ,qBAAqB,EAAE;AAC/B,QAAQ,mBAAmB,EAAE;AAC7B,QAAQ,oBAAoB,EAAE;AAC9B,QAAQ,iBAAiB,EAAE;AAC3B,QAAQ,mBAAmB,EAAE;AAC7B,QAAQ,mBAAmB,EAAE;;AAE7B,WAAW;AACX,YAAY,uBAAuB,EAAE;AACrC,cAAc,yBAAyB,EAAE;AACzC,eAAe,yBAAyB,EAAE;AAC1C,cAAc,yBAAyB,EAAE;AACzC,cAAc,yBAAyB,EAAE;AACzC,YAAY,yBAAyB,EAAE;AACvC,kBAAkB,6BAA6B,EAAE;AACjD,cAAc,yBAAyB,EAAE;AACzC,eAAe,yBAAyB,EAAE;AAC1C,eAAe,yBAAyB,EAAE;AAC1C,gBAAgB,yBAAyB,EAAE;AAC3C,gBAAgB,yBAAyB,EAAE;AAC3C,iBAAiB,yBAAyB,EAAE;AAC5C,iBAAiB,yBAAyB,EAAE;AAC5C,cAAc,yBAAyB,EAAE;AACzC,cAAc,yBAAyB,EAAE;AACzC,cAAc,YAAY,EAAE;AAC5B,cAAc,cAAc,EAAE;AAC9B,iBAAiB,cAAc,EAAE;AACjC,iBAAiB,cAAc,EAAE;AACjC,gBAAgB,cAAc,EAAE;AAChC,aAAa,cAAc,EAAE;AAC7B,iBAAiB,cAAc,EAAE;AACjC,kBAAkB,cAAc,EAAE;;AAElC,YAAY;AACZ,UAAU,iBAAiB,EAAE;AAC7B,YAAY,iBAAiB,EAAE;AAC/B,YAAY,uBAAuB,EAAE;AACrC,YAAY,wBAAwB,EAAE;AACtC,cAAc,sBAAsB,EAAE;AACtC,sBAAsB,qBAAqB,EAAE;AAC7C,mBAAmB,qBAAqB,EAAE;AAC1C,gBAAgB,mBAAmB,EAAE;AACrC,kBAAkB,qBAAqB,EAAE;AACzC,mBAAmB,qBAAqB,EAAE;AAC1C,oBAAoB,qBAAqB,EAAE;AAC3C,WAAW,sBAAsB,EAAE;AACnC,cAAc,qBAAqB,EAAE;AACrC,cAAc,sBAAsB,EAAE;;AAEtC,YAAY;AACZ,aAAa,2CAA2C,EAAE;AAC1D,aAAa,iFAAiF,EAAE;AAChG,aAAa,mFAAmF,EAAE;AAClG,gBAAgB,yCAAyC,EAAE;;AAE3D,eAAe;AACf,aAAa,gCAAgC,EAAE;AAC/C,cAAc,sCAAsC,EAAE;AACtD,eAAe,gBAAgB,EAAE;AACjC,iBAAiB,gBAAgB,EAAE;AACnC,aAAa,gBAAgB,EAAE;AAC/B,WAAW,kBAAkB,EAAE;AAC/B,WAAW,mBAAmB,EAAE;AAChC,WAAW,mBAAmB,EAAE;AAChC,WAAW,kBAAkB,EAAE;AAC/B,YAAY,iBAAiB,EAAE;AAC/B,YAAY,mBAAmB,EAAE;AACjC,aAAa,yBAAyB,EAAE;AACxC,kBAAkB,sBAAsB,EAAE;;AAE1C,aAAa;AACb,mBAAmB,gBAAgB,EAAE;AACrC,mBAAmB,gBAAgB,EAAE;;AAErC,gBAAgB;AAChB,kBAAkB,oBAAoB,EAAE;AACxC,gBAAgB,0BAA0B,EAAE;AAC5C,wBAAwB,0BAA0B,EAAE;AACpD,qBAAqB,gEAAgE,EAAE;;AAEvF,eAAe;AACf,cAAc,yBAAyB,EAAE;AACzC,aAAa,+LAA+L,EAAE;AAC9M,+BAA+B,+BAA+B,EAAE;;AAEhE,kBAAkB;AAClB,2BAA2B,yBAAyB,EAAE;AACtD,2BAA2B,yBAAyB,EAAE;AACtD,yBAAyB,uBAAuB,EAAE;AAClD,4BAA4B,yBAAyB,EAAE;AACvD,6BAA6B,yBAAyB,EAAE;AACxD,8BAA8B,yBAAyB,EAAE;AACzD,2BAA2B,yBAAyB,EAAE;AACtD,6BAA6B,cAAc,EAAE;AAC7C,2BAA2B,cAAc,EAAE;AAC3C,0BAA0B,iFAAiF,EAAE;;AAE7G,aAAa;AACb,YAAY,kBAAkB,EAAE;AAChC,YAAY,kBAAkB,EAAE;AAChC,SAAS,MAAM,EAAE;AACjB,UAAU,OAAO,EAAE;;AAEnB,YAAY;AACZ,SAAS,cAAc,EAAE;AACzB,gBAAgB,qBAAqB,EAAE;AACvC,UAAU,aAAa,EAAE;;AAEzB,WAAW;AACX,kBAAkB,eAAe,EAAE;;AAEnC,oBAAoB;AACpB,gBAAgB,qBAAqB,EAAE;;AAEvC,2BAA2B;AAC3B;EACE,YAAY,oBAAoB,EAAE,uBAAuB,EAAE;EAC3D,YAAY,iBAAiB,EAAE,oBAAoB,EAAE;EACrD,YAAY,kBAAkB,EAAE,mBAAmB,EAAE;EACrD,iBAAiB,eAAe,EAAE;EAClC,eAAe,mBAAmB,EAAE;AACtC;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,6DAA6D;EAC7D,gCAAgC;EAChC,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,8CAA8C;EAC9C,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,WAAW;EACX,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,YAAY;EACZ,sCAAsC;EACtC,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,kBAAkB;AACpB;;AAEA,eAAe;AACf;EACE,YAAY;EACZ,aAAa;EACb,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,eAAe;AACjB;;AAEA,iBAAiB;AACjB;EACE,4DAA4D;AAC9D;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA,gBAAgB;AAChB;EACE,qIAAqI;EACrI,sBAAsB;EACtB,+BAA+B;AACjC;;AAEA;EACE,2HAA2H;AAC7H;;AAEA,cAAc;AACd;EACE,cAAc;EACd,kCAAkC;AACpC;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA,uBAAuB;AACvB;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,SAAO;AACT;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,qCAAqC;AACvC;;AAEA;EACE,SAAO;EACP,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,YAAY;EACZ,qBAAqB;EACrB,iCAAiC;AACnC;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,kBAAkB;AACpB;;AAEA,sBAAsB;AACtB;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;;EAGE,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,uBAAuB;EACvB,mBAAmB;EACnB,wEAAwE;AAC1E;;AAEA;;;EAGE,UAAU;EACV,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,wBAAwB;AACxB;EACE,uBAAuB;EACvB,YAAY;EACZ,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;EACrB,qBAAqB;EACrB,eAAe;EACf,iCAAiC;EACjC,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA,sBAAsB;AACtB;EACE,iBAAiB;EACjB,qBAAqB;EACrB,qCAAqC;EACrC,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA,uBAAuB;AACvB;EACE,WAAW;EACX,yBAAyB;EACzB,cAAc;AAChB;;AAEA;;EAEE,gBAAgB;EAChB,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;AAChB;;AAEA,0BAA0B;AAC1B,eAAe,kBAAkB,EAAE;AACnC,cAAc,iBAAiB,EAAE;AACjC,QAAQ,mBAAmB,EAAE;AAC7B,QAAQ,mBAAmB,EAAE;AAC7B,QAAQ,gBAAgB,EAAE;AAC1B,QAAQ,aAAa,EAAE;AACvB,UAAU,SAAO,EAAE;AACnB,gBAAgB,mBAAmB,EAAE;AACrC,mBAAmB,8BAA8B,EAAE;AACnD,SAAS,SAAS,EAAE;AACpB,UAAU,aAAa,EAAE;;AAEzB;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,aAAa;EACf;AACF;;AAEA,6BAA6B;AAC7B;EACE,2BAA2B;EAC3B,2CAA2C;AAC7C;;AAEA;EACE,2CAA2C;EAC3C,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;;EAEE,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;;EAEE,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;;;;;EAME,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;;;;;;EAME,aAAa;AACf;;AAEA,wBAAwB,eAAe,EAAE;AACzC,wBAAwB,iBAAiB,EAAE;AAC3C,wBAAwB,kBAAkB,EAAE;AAC5C,wBAAwB,mBAAmB,EAAE;AAC7C,wBAAwB,eAAe,EAAE;AACzC,wBAAwB,mBAAmB,EAAE;;AAE7C;;EAEE,gBAAgB;AAClB;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,8BAA8B;EAC9B,kBAAkB;EAClB,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,sBAAsB;EACtB,qCAAqC;EACrC,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,qBAAqB;EACrB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;EAC7B,UAAU;AACZ;;AAEA,iDAAiD;AACjD;EACE,8BAA8B;AAChC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA,sCAAsC;AACtC;EACE,oBAAoB;EACpB,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA,8CAA8C;AAC9C;EACE,2BAA2B;EAC3B,6BAA6B;AAC/B;;AAEA,2DAA2D;AAC3D;EACE,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,aAAa;AACf;;AAEA,qDAAqD;AACrD;EACE,aAAa;AACf;;AAEA,mDAAmD;AACnD;EACE,SAAS;EACT,UAAU;EACV,aAAa;AACf","sourcesContent":["/* Reset and base styles */\n* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n\nbody {\n  background-color: #f1f5f9;\n  color: #1e293b;\n  font-family: 'Inter', sans-serif;\n  height: 100vh;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n\n/* Utility classes for layout */\n.min-h-screen { min-height: 100vh; }\n.h-screen { height: 100vh; }\n.flex { display: flex; }\n.flex-col { flex-direction: column; }\n.flex-1 { flex: 1; }\n.items-center { align-items: center; }\n.justify-center { justify-content: center; }\n.justify-between { justify-content: space-between; }\n.gap-1 { gap: 0.25rem; }\n.gap-2 { gap: 0.5rem; }\n.gap-3 { gap: 0.75rem; }\n.gap-4 { gap: 1rem; }\n.gap-6 { gap: 1.5rem; }\n.space-y-1 > * + * { margin-top: 0.25rem; }\n.space-y-4 > * + * { margin-top: 1rem; }\n.space-y-6 > * + * { margin-top: 1.5rem; }\n.space-x-2 > * + * { margin-left: 0.5rem; }\n\n/* Width and sizing */\n.w-4 { width: 1rem; }\n.w-5 { width: 1.25rem; }\n.w-10 { width: 2.5rem; }\n.w-12 { width: 3rem; }\n.w-64 { width: 16rem; }\n.w-full { width: 100%; }\n.h-12 { height: 3rem; }\n\n/* Padding and margin */\n.p-4 { padding: 1rem; }\n.p-6 { padding: 1.5rem; }\n.p-8 { padding: 2rem; }\n.px-2 { padding-left: 0.5rem; padding-right: 0.5rem; }\n.px-4 { padding-left: 1rem; padding-right: 1rem; }\n.px-6 { padding-left: 1.5rem; padding-right: 1.5rem; }\n.px-8 { padding-left: 2rem; padding-right: 2rem; }\n.py-1 { padding-top: 0.25rem; padding-bottom: 0.25rem; }\n.py-2 { padding-top: 0.5rem; padding-bottom: 0.5rem; }\n.py-2\\.5 { padding-top: 0.625rem; padding-bottom: 0.625rem; }\n.py-3 { padding-top: 0.75rem; padding-bottom: 0.75rem; }\n.py-4 { padding-top: 1rem; padding-bottom: 1rem; }\n.pb-4 { padding-bottom: 1rem; }\n.mb-2 { margin-bottom: 0.5rem; }\n.mb-3 { margin-bottom: 0.75rem; }\n.mb-4 { margin-bottom: 1rem; }\n.mb-6 { margin-bottom: 1.5rem; }\n.mb-8 { margin-bottom: 2rem; }\n.ml-3 { margin-left: 0.75rem; }\n.ml-4 { margin-left: 1rem; }\n.ml-6 { margin-left: 1.5rem; }\n.mt-1 { margin-top: 0.25rem; }\n\n/* Colors */\n.bg-white { background-color: white; }\n.bg-gray-50 { background-color: #f9fafb; }\n.bg-gray-100 { background-color: #f3f4f6; }\n.bg-surface { background-color: #f1f5f9; }\n.bg-crimson { background-color: #981b1e; }\n.bg-slate { background-color: #1e293b; }\n.bg-transparent { background-color: transparent; }\n.bg-red-800 { background-color: #991b1b; }\n.bg-blue-500 { background-color: #3b82f6; }\n.bg-blue-600 { background-color: #2563eb; }\n.bg-green-500 { background-color: #10b981; }\n.bg-green-600 { background-color: #059669; }\n.bg-purple-500 { background-color: #8b5cf6; }\n.bg-purple-600 { background-color: #7c3aed; }\n.bg-red-500 { background-color: #ef4444; }\n.bg-red-600 { background-color: #dc2626; }\n.text-white { color: white; }\n.text-slate { color: #1e293b; }\n.text-gray-500 { color: #6b7280; }\n.text-gray-600 { color: #4b5563; }\n.text-crimson { color: #981b1e; }\n.text-gold { color: #d4af37; }\n.text-blue-500 { color: #3b82f6; }\n.text-green-500 { color: #10b981; }\n\n/* Borders */\n.border { border-width: 1px; }\n.border-2 { border-width: 2px; }\n.border-r { border-right-width: 1px; }\n.border-b { border-bottom-width: 1px; }\n.border-l-4 { border-left-width: 4px; }\n.border-border_gray { border-color: #e2e8f0; }\n.border-gray-200 { border-color: #e5e7eb; }\n.border-white { border-color: white; }\n.border-crimson { border-color: #981b1e; }\n.border-blue-500 { border-color: #3b82f6; }\n.border-green-500 { border-color: #10b981; }\n.rounded { border-radius: 0.25rem; }\n.rounded-lg { border-radius: 0.5rem; }\n.rounded-xl { border-radius: 0.75rem; }\n\n/* Shadows */\n.shadow-sm { box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05); }\n.shadow-md { box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06); }\n.shadow-lg { box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05); }\n.shadow-float { box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1); }\n\n/* Typography */\n.font-sans { font-family: 'Inter', sans-serif; }\n.font-serif { font-family: 'Playfair Display', serif; }\n.font-medium { font-weight: 500; }\n.font-semibold { font-weight: 600; }\n.font-bold { font-weight: 700; }\n.text-xs { font-size: 0.75rem; }\n.text-sm { font-size: 0.875rem; }\n.text-lg { font-size: 1.125rem; }\n.text-xl { font-size: 1.25rem; }\n.text-2xl { font-size: 1.5rem; }\n.text-3xl { font-size: 1.875rem; }\n.uppercase { text-transform: uppercase; }\n.tracking-wider { letter-spacing: 0.05em; }\n\n/* Overflow */\n.overflow-hidden { overflow: hidden; }\n.overflow-y-auto { overflow-y: auto; }\n\n/* Transitions */\n.transition-all { transition: all 0.2s; }\n.duration-200 { transition-duration: 200ms; }\n.transition-transform { transition: transform 0.2s; }\n.transition-colors { transition: color 0.2s, background-color 0.2s, border-color 0.2s; }\n\n/* Transforms */\n.rotate-180 { transform: rotate(180deg); }\n.transform { transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)); }\n.hover\\:-translate-y-1:hover { transform: translateY(-0.25rem); }\n\n/* Hover effects */\n.hover\\:bg-gray-50:hover { background-color: #f9fafb; }\n.hover\\:bg-red-800:hover { background-color: #991b1b; }\n.hover\\:bg-white:hover { background-color: white; }\n.hover\\:bg-blue-600:hover { background-color: #2563eb; }\n.hover\\:bg-green-600:hover { background-color: #059669; }\n.hover\\:bg-purple-600:hover { background-color: #7c3aed; }\n.hover\\:bg-red-600:hover { background-color: #dc2626; }\n.hover\\:text-crimson:hover { color: #981b1e; }\n.hover\\:text-slate:hover { color: #1e293b; }\n.hover\\:shadow-md:hover { box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06); }\n\n/* Position */\n.absolute { position: absolute; }\n.relative { position: relative; }\n.top-0 { top: 0; }\n.left-0 { left: 0; }\n\n/* Display */\n.block { display: block; }\n.inline-block { display: inline-block; }\n.hidden { display: none; }\n\n/* Cursor */\n.cursor-pointer { cursor: pointer; }\n\n/* Text decoration */\n.no-underline { text-decoration: none; }\n\n/* Responsive breakpoints */\n@media (min-width: 640px) {\n  .sm\\:py-3 { padding-top: 0.75rem; padding-bottom: 0.75rem; }\n  .sm\\:py-4 { padding-top: 1rem; padding-bottom: 1rem; }\n  .sm\\:px-8 { padding-left: 2rem; padding-right: 2rem; }\n  .sm\\:text-base { font-size: 1rem; }\n  .sm\\:text-lg { font-size: 1.125rem; }\n}\n\n/* BRAND LOGO STYLES */\n.brand-logo {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  text-decoration: none;\n}\n\n.shield-icon {\n  width: 42px;\n  height: 50px;\n  background: linear-gradient(135deg, #981b1e 0%, #721215 100%);\n  border-radius: 4px 4px 24px 24px;\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  box-shadow: 0 4px 10px rgba(152, 27, 30, 0.25);\n  flex-shrink: 0;\n}\n\n.shield-icon::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 4px;\n  background: #d4af37;\n  border-radius: 4px 4px 0 0;\n}\n\n.shield-char {\n  color: white;\n  font-family: 'Playfair Display', serif;\n  font-weight: 900;\n  font-size: 28px;\n  margin-top: 3px;\n  font-style: italic;\n}\n\n/* Large Logo */\n.shield-icon.large {\n  width: 120px;\n  height: 144px;\n  border-radius: 8px 8px 60px 60px;\n}\n\n.shield-icon.large::before {\n  height: 8px;\n  border-radius: 8px 8px 0 0;\n}\n\n.shield-icon.large .shield-char {\n  font-size: 80px;\n  margin-top: 6px;\n}\n\n/* UI UTILITIES */\n.fade-in {\n  animation: fadeIn 0.4s cubic-bezier(0.4, 0, 0.2, 1) forwards;\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n    transform: translateY(10px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n::-webkit-scrollbar {\n  width: 6px;\n}\n\n::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n::-webkit-scrollbar-thumb {\n  background: #cbd5e1;\n  border-radius: 3px;\n}\n\n/* HERO STYLES */\n.hero-bg-image {\n  background-image: url('https://images.unsplash.com/photo-1523580494863-6f3031224c94?ixlib=rb-1.2.1&auto=format&fit=crop&w=1950&q=80');\n  background-size: cover;\n  background-position: center 20%;\n}\n\n.hero-overlay {\n  background: linear-gradient(to right, rgba(152, 27, 30, 0.95) 0%, rgba(152, 27, 30, 0.7) 60%, rgba(212, 175, 55, 0.2) 100%);\n}\n\n/* MEGA MENU */\n.group:hover .mega-menu {\n  display: block;\n  animation: slideDown 0.2s ease-out;\n}\n\n@keyframes slideDown {\n  from {\n    opacity: 0;\n    transform: translateY(10px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n/* ADMIN PANEL STYLES */\n.admin-container {\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n}\n\n.admin-header {\n  background: #1f2937;\n  color: white;\n  padding: 1rem 2rem;\n  box-shadow: 0 2px 4px rgba(0,0,0,0.1);\n}\n\n.admin-main {\n  display: flex;\n  flex: 1;\n}\n\n.admin-sidebar {\n  width: 250px;\n  background: #374151;\n  color: white;\n  padding: 1rem 0;\n  box-shadow: 2px 0 4px rgba(0,0,0,0.1);\n}\n\n.admin-content {\n  flex: 1;\n  padding: 2rem;\n  background: #f9fafb;\n}\n\n.sidebar-nav {\n  list-style: none;\n}\n\n.sidebar-nav li {\n  border-bottom: 1px solid #4b5563;\n}\n\n.sidebar-nav a {\n  display: block;\n  padding: 1rem 1.5rem;\n  color: white;\n  text-decoration: none;\n  transition: background-color 0.2s;\n}\n\n.sidebar-nav a:hover,\n.sidebar-nav a.active {\n  background: #1f2937;\n}\n\n.sidebar-nav i {\n  margin-right: 0.75rem;\n  width: 1.25rem;\n  text-align: center;\n}\n\n/* Admin Form Styles */\n.form-group {\n  margin-bottom: 1.5rem;\n}\n\n.form-label {\n  display: block;\n  margin-bottom: 0.5rem;\n  font-weight: 600;\n  color: #374151;\n}\n\n.form-input,\n.form-textarea,\n.form-select {\n  width: 100%;\n  padding: 0.75rem;\n  border: 1px solid #d1d5db;\n  border-radius: 0.375rem;\n  font-size: 0.875rem;\n  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n}\n\n.form-input:focus,\n.form-textarea:focus,\n.form-select:focus {\n  outline: 0;\n  border-color: #3b82f6;\n  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\n}\n\n.form-textarea {\n  min-height: 100px;\n  resize: vertical;\n}\n\n/* Admin Button Styles */\n.btn {\n  padding: 0.75rem 1.5rem;\n  border: none;\n  border-radius: 0.375rem;\n  font-weight: 600;\n  text-align: center;\n  text-decoration: none;\n  display: inline-block;\n  cursor: pointer;\n  transition: all 0.15s ease-in-out;\n  font-size: 0.875rem;\n}\n\n.btn-primary {\n  background: #3b82f6;\n  color: white;\n}\n\n.btn-primary:hover {\n  background: #2563eb;\n}\n\n.btn-secondary {\n  background: #6b7280;\n  color: white;\n}\n\n.btn-secondary:hover {\n  background: #4b5563;\n}\n\n.btn-success {\n  background: #10b981;\n  color: white;\n}\n\n.btn-success:hover {\n  background: #059669;\n}\n\n.btn-danger {\n  background: #ef4444;\n  color: white;\n}\n\n.btn-danger:hover {\n  background: #dc2626;\n}\n\n.btn-sm {\n  padding: 0.5rem 1rem;\n  font-size: 0.75rem;\n}\n\n/* Admin Card Styles */\n.card {\n  background: white;\n  border-radius: 0.5rem;\n  box-shadow: 0 1px 3px rgba(0,0,0,0.1);\n  overflow: hidden;\n}\n\n.card-header {\n  padding: 1.5rem 2rem;\n  border-bottom: 1px solid #e5e7eb;\n  background: #f9fafb;\n}\n\n.card-title {\n  font-size: 1.25rem;\n  font-weight: 600;\n  color: #111827;\n}\n\n.card-body {\n  padding: 2rem;\n}\n\n/* Admin Table Styles */\n.table {\n  width: 100%;\n  border-collapse: collapse;\n  margin: 1rem 0;\n}\n\n.table th,\n.table td {\n  padding: 0.75rem;\n  text-align: left;\n  border-bottom: 1px solid #e5e7eb;\n}\n\n.table th {\n  background: #f9fafb;\n  font-weight: 600;\n  color: #374151;\n}\n\n.table tbody tr:hover {\n  background: #f9fafb;\n}\n\n/* Admin Alert Styles */\n.alert {\n  padding: 1rem;\n  border-radius: 0.375rem;\n  margin-bottom: 1rem;\n}\n\n.alert-success {\n  background: #d1fae5;\n  border: 1px solid #34d399;\n  color: #065f46;\n}\n\n.alert-error {\n  background: #fee2e2;\n  border: 1px solid #f87171;\n  color: #991b1b;\n}\n\n.alert-warning {\n  background: #fef3c7;\n  border: 1px solid #fbbf24;\n  color: #92400e;\n}\n\n/* Admin Utility Classes */\n.text-center { text-align: center; }\n.text-right { text-align: right; }\n.mb-4 { margin-bottom: 1rem; }\n.mb-8 { margin-bottom: 2rem; }\n.mt-4 { margin-top: 1rem; }\n.flex { display: flex; }\n.flex-1 { flex: 1; }\n.items-center { align-items: center; }\n.justify-between { justify-content: space-between; }\n.gap-4 { gap: 1rem; }\n.hidden { display: none; }\n\n@media (max-width: 768px) {\n  .admin-main {\n    flex-direction: column;\n  }\n  \n  .admin-sidebar {\n    width: 100%;\n  }\n  \n  .admin-content {\n    padding: 1rem;\n  }\n}\n\n/* Rich Text Content Styles */\n.rich-text-content {\n  line-height: 1.7 !important;\n  font-family: 'Inter', sans-serif !important;\n}\n\n.rich-text-content *:not(code):not(pre) {\n  font-family: 'Inter', sans-serif !important;\n  line-height: 1.7 !important;\n}\n\n.rich-text-content p {\n  margin-bottom: 1rem;\n}\n\n.rich-text-content p:last-child {\n  margin-bottom: 0;\n}\n\n.rich-text-content ul, \n.rich-text-content ol {\n  margin-left: 1.5rem;\n  margin-bottom: 1rem;\n  padding-left: 0.5rem;\n}\n\n.rich-text-content ul {\n  list-style-type: disc;\n}\n\n.rich-text-content ol {\n  list-style-type: decimal;\n}\n\n.rich-text-content ul ul, \n.rich-text-content ol ul {\n  list-style-type: circle;\n  margin-top: 0.5rem;\n}\n\n.rich-text-content ol ol, \n.rich-text-content ul ol {\n  list-style-type: lower-alpha;\n  margin-top: 0.5rem;\n}\n\n.rich-text-content li {\n  margin-bottom: 0.5rem;\n  padding-left: 0.25rem;\n}\n\n.rich-text-content li:last-child {\n  margin-bottom: 0;\n}\n\n.rich-text-content h1, \n.rich-text-content h2, \n.rich-text-content h3, \n.rich-text-content h4, \n.rich-text-content h5, \n.rich-text-content h6 {\n  font-weight: 600;\n  margin-bottom: 0.75rem;\n  margin-top: 1.5rem;\n}\n\n.rich-text-content h1:first-child, \n.rich-text-content h2:first-child, \n.rich-text-content h3:first-child, \n.rich-text-content h4:first-child, \n.rich-text-content h5:first-child, \n.rich-text-content h6:first-child {\n  margin-top: 0;\n}\n\n.rich-text-content h1 { font-size: 2rem; }\n.rich-text-content h2 { font-size: 1.5rem; }\n.rich-text-content h3 { font-size: 1.25rem; }\n.rich-text-content h4 { font-size: 1.125rem; }\n.rich-text-content h5 { font-size: 1rem; }\n.rich-text-content h6 { font-size: 0.875rem; }\n\n.rich-text-content strong, \n.rich-text-content b {\n  font-weight: 600;\n}\n\n.rich-text-content em, \n.rich-text-content i {\n  font-style: italic;\n}\n\n.rich-text-content u {\n  text-decoration: underline;\n}\n\n.rich-text-content blockquote {\n  border-left: 4px solid #e5e7eb;\n  padding-left: 1rem;\n  margin-left: 0;\n  margin-bottom: 1rem;\n  font-style: italic;\n  color: #6b7280;\n}\n\n.rich-text-content a {\n  color: #3b82f6;\n  text-decoration: underline;\n}\n\n.rich-text-content a:hover {\n  color: #1d4ed8;\n}\n\n.rich-text-content code {\n  background-color: #f3f4f6;\n  padding: 0.125rem 0.25rem;\n  border-radius: 0.25rem;\n  font-family: 'Courier New', monospace;\n  font-size: 0.875em;\n}\n\n.rich-text-content pre {\n  background-color: #f3f4f6;\n  padding: 1rem;\n  border-radius: 0.5rem;\n  overflow-x: auto;\n  margin-bottom: 1rem;\n}\n\n.rich-text-content pre code {\n  background-color: transparent;\n  padding: 0;\n}\n\n/* Preserve inline styles from rich text editor */\n.rich-text-content p[style*=\"text-align: justify\"] {\n  text-align: justify !important;\n}\n\n.rich-text-content p[style*=\"text-align: left\"] {\n  text-align: left !important;\n}\n\n.rich-text-content p[style*=\"text-align: center\"] {\n  text-align: center !important;\n}\n\n.rich-text-content p[style*=\"text-align: right\"] {\n  text-align: right !important;\n}\n\n/* Support for MS Word-style classes */\n.rich-text-content .MsoNormal {\n  margin: 0 !important;\n  padding: 0 !important;\n  line-height: 1.7 !important;\n}\n\n/* Override Word/CMS inline spacing on spans */\n.rich-text-content span {\n  line-height: 1.7 !important;\n  font-size: inherit !important;\n}\n\n/* Preserve line breaks and spacing from rich text editor */\n.rich-text-content br {\n  line-height: 1.7;\n}\n\n.rich-text-content p:empty {\n  margin-bottom: 0.5rem;\n  min-height: 0;\n}\n\n.rich-text-content div:empty {\n  margin-bottom: 0.5rem;\n  min-height: 0;\n}\n\n/* Ensure proper spacing for consecutive paragraphs */\n.rich-text-content p + p {\n  margin-top: 0;\n}\n\n/* Remove extra spacing from hidden/blank content */\n.rich-text-content *:empty:not(br):not(img) {\n  margin: 0;\n  padding: 0;\n  min-height: 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
